import {
  Container,
  Typography,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";
import BarCards from "../../../../assets/images/Bar - Cards.png";
import BarVoids from "../../../../assets/images/Bar - Voids & Replacements.png";
import BarFulfillment from "../../../../assets/images/Bar - Flfilment.png";
import BarBrowser from "../../../../assets/images/Bar - Browser.png";
import { forensicBlocks } from "./constants";

const PURPLE = "#7B1FA2";
const DARK_BLUE = "#1A2F6B";

const useStyles = makeStyles((theme) => ({
  /* ── Omnichannel Strip ── */
  omnichannelStrip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 3),
    background: "linear-gradient(90deg, rgba(0,188,212,0.08), rgba(123,31,162,0.08))",
    border: "2px solid #7B1FA2",
    borderRadius: 30,
    position: "relative",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  omnichannelLabel: {
    fontWeight: "bold",
    color: DARK_BLUE,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: 1,
    whiteSpace: "nowrap",
  },
  omnichannelItem: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    color: DARK_BLUE,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  omnichannelIcon: {
    height: 20,
    objectFit: "contain",
  },
  omnichannelDot: {
    color: PURPLE,
    fontWeight: "bold",
  },

  /* ── Section Title ── */
  sectionTitle: {
    fontFamily: "Akzidenz-Grotesk BQ, serif",
    textTransform: "uppercase",
    color: DARK_BLUE,
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
  },

  /* ── Forensic Block Rows ── */
  forensicBlockRow: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(12),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(4),
    },
  },

  /* ── Single Forensic Block (icon ── line ── [card] ── line ── icon) ── */
  forensicBlock: {
    display: "flex",
    alignItems: "center",
    width: 520,
    maxWidth: "100%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  sideIconLeft: {
    position: "absolute",
    top: 52,
    left: -28,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  sideIconRight: {
    position: "absolute",
    top: 52,
    right: -28,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  sideIcon: {
    width: 64,
    height: 64,
    objectFit: "contain",
  },
  connectorLeft: {
    width: 50,
    height: 2,
    flexShrink: 0,
    background: `linear-gradient(90deg, #E040FB, ${PURPLE})`,
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: 2,
      height: 52,
      background: `linear-gradient(180deg, #E040FB, ${PURPLE})`,
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  connectorRight: {
    width: 50,
    height: 2,
    flexShrink: 0,
    background: `linear-gradient(90deg, ${PURPLE}, #E040FB)`,
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: 2,
      height: 52,
      background: `linear-gradient(180deg, #E040FB, ${PURPLE})`,
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  cardBorderWrap: {
    flex: 1,
    border: `2px solid ${PURPLE}`,
    borderRadius: 16,
    padding: 2,
    position: "relative",
    minWidth: 0,
  },
  forensicCard: {
    borderRadius: 12,
    overflow: "hidden",
    background: "#fff",
  },
  cardHeader: {
    background: "linear-gradient(135deg, #1565C0 0%, #7B1FA2 100%)",
    padding: theme.spacing(1.5, 2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  cardHeaderIcon: {
    width: 40,
    height: 40,
    objectFit: "contain",
    borderRadius: 8,
    background: "rgba(255,255,255,0.15)",
    padding: 4,
  },
  cardHeaderTitle: {
    color: "#fff",
    fontWeight: "bold",
    textTransform: "uppercase",
    lineHeight: 1.3,
  },
  powerStatBadge: {
    background: "linear-gradient(90deg, #FF8F00 0%, #FFD54F 100%)",
    padding: theme.spacing(0.6, 2),
    display: "inline-block",
    borderRadius: "0 0 8px 0",
  },
  powerStatText: {
    fontWeight: 800,
    color: DARK_BLUE,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  cardBody: {
    padding: theme.spacing(1.5, 2),
    fontSize: theme.typography.body1.fontSize,
    lineHeight: 1.7,
    color: "#444",
    "& strong": {
      color: PURPLE,
      fontWeight: "bold",
    },
  },


  /* ── Closing Section ── */
  closingTitle: {
    fontFamily: "Akzidenz-Grotesk BQ, serif",
    textTransform: "uppercase",
    color: DARK_BLUE,
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
  },
  closingBody: {
    color: theme.palette.secondary.main,
    lineHeight: 1.8,
    marginBottom: theme.spacing(2),
  },
  closingBold: {
    fontWeight: "bold",
    color: DARK_BLUE,
    marginBottom: theme.spacing(4),
  },
  ctaSection: {
    textAlign: "center",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  ctaButton: {
    fontWeight: "bold",
    padding: theme.spacing(1.5, 4),
    background: "linear-gradient(90deg, #1565C0, #7B1FA2)",
    color: "#fff",
    borderRadius: 6,
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(90deg, #0D47A1, #6A1B9A)",
    },
  },
  ctaSubtext: {
    color: theme.palette.secondary.main,
    fontStyle: "italic",
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(6),
  },
}));

function ForensicBlock({ block, classes }) {
  return (
    <div className={classes.forensicBlock}>
      {/* Left L-connector with icon at bottom */}
      <div className={classes.connectorLeft}>
        <div className={classes.sideIconLeft}>
          <img src={block.leftIcon} alt="" className={classes.sideIcon} />
        </div>
      </div>

      {/* Card with border */}
      <div className={classes.cardBorderWrap}>
        <div className={classes.forensicCard}>
          <div className={classes.cardHeader}>
            <img
              src={block.headerIcon}
              alt=""
              className={classes.cardHeaderIcon}
            />
            <Typography variant="subtitle1" className={classes.cardHeaderTitle}>{block.title}</Typography>
          </div>
          <div className={classes.powerStatBadge}>
            <Typography variant="body1" className={classes.powerStatText}>{block.powerStat}</Typography>
          </div>
          <div
            className={classes.cardBody}
            dangerouslySetInnerHTML={{ __html: block.description }}
          />
        </div>
      </div>

      {/* Right L-connector with icon at bottom */}
      <div className={classes.connectorRight}>
        <div className={classes.sideIconRight}>
          <img src={block.rightIcon} alt="" className={classes.sideIcon} />
        </div>
      </div>
    </div>
  );
}

export default function GiftCardsContent() {
  const classes = useStyles();
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container>
      <Fragment>
        {/* Omnichannel Strip */}
        <div className={classes.omnichannelStrip}>
          <Typography variant={xs ? "body2" : "body1"} component="span" className={classes.omnichannelLabel}>OMNICHANNEL READY:</Typography>
          <Typography variant={xs ? "body2" : "body1"} component="span" className={classes.omnichannelItem}>
            <img src={BarCards} alt="" className={classes.omnichannelIcon} />
            PHYSICAL &amp; DIGITAL CARDS
          </Typography>
          <span className={classes.omnichannelDot}>&bull;</span>
          <Typography variant={xs ? "body2" : "body1"} component="span" className={classes.omnichannelItem}>
            <img src={BarVoids} alt="" className={classes.omnichannelIcon} />
            INSTANT VOID &amp; REPLACEMENT
          </Typography>
          <span className={classes.omnichannelDot}>&bull;</span>
          <Typography variant={xs ? "body2" : "body1"} component="span" className={classes.omnichannelItem}>
            <img src={BarFulfillment} alt="" className={classes.omnichannelIcon} />
            B2B BULK FULFILLMENT
          </Typography>
          <span className={classes.omnichannelDot}>&bull;</span>
          <Typography variant={xs ? "body2" : "body1"} component="span" className={classes.omnichannelItem}>
            <img src={BarBrowser} alt="" className={classes.omnichannelIcon} />
            100% BROWSER BASED
          </Typography>
        </div>

        {/* Forensic Section Title */}
        <Typography
          variant={xs ? "h6" : sm ? "h5" : "h4"}
          className={classes.sectionTitle}
        >
          GIFT CARD MANAGEMENT WITH THE BRAIN OF
          <br />
          A FORENSIC DATA-ANALYTICS TOOL.
        </Typography>

        {/* Row 1: Hardware-Free + Forensic Ledger */}
        <div className={classes.forensicBlockRow}>
          <ForensicBlock block={forensicBlocks[0]} classes={classes} />
          <ForensicBlock block={forensicBlocks[1]} classes={classes} />
        </div>

        {/* Row 2: Advanced Card Security + Secure User Experience */}
        <div className={classes.forensicBlockRow}>
          <ForensicBlock block={forensicBlocks[2]} classes={classes} />
          <ForensicBlock block={forensicBlocks[3]} classes={classes} />
        </div>

        {/* Row 3: Effortless Scalability + Revenue Recapture */}
        <div className={classes.forensicBlockRow}>
          <ForensicBlock block={forensicBlocks[4]} classes={classes} />
          <ForensicBlock block={forensicBlocks[5]} classes={classes} />
        </div>

        {/* Closing Section */}
        <Typography
          variant={xs ? "h6" : sm ? "h5" : "h4"}
          className={classes.closingTitle}
        >
          PRECISION OVERSIGHT. ZERO FRICTION. TOTAL GROWTH.
        </Typography>

        <Typography
          variant={xs ? "body2" : "body1"}
          className={classes.closingBody}
        >
          We&rsquo;ve replaced the complexity of legacy gift card management with a
          unified intelligence layer. By combining forensic financial accuracy with
          a cloud-native, hardware-free deployment, we empower your entire
          organization - from the IT suite to the storefront - to turn gift
          card data into a strategic asset.
        </Typography>

        <Typography
          variant={xs ? "body2" : "body1"}
          className={classes.closingBold}
        >
          No more black boxes. No more manual reconciliation. Just real-time
          profit.
        </Typography>

        {/* CTA */}
        <div className={classes.ctaSection}>
          <Button
            variant="contained"
            className={classes.ctaButton}
            component={RouterLink}
            to="/contact"
            onClick={() => window.scrollTo(0, 0)}
          >
            Contact Us to Explore the YOOZ Gift Card Programme
          </Button>
          <Typography variant="body2" className={classes.ctaSubtext}>
            No IT integration required. See your unclaimed revenue today.
          </Typography>
        </div>
      </Fragment>
    </Container>
  );
}
